import { render, staticRenderFns } from "./EmailChange.vue?vue&type=template&id=708c3715&scoped=true&"
import script from "./EmailChange.vue?vue&type=script&lang=js&"
export * from "./EmailChange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708c3715",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VRow})
